import { render } from "./ContactUsComp.vue?vue&type=template&id=0010b525&scoped=true"
import script from "./ContactUsComp.vue?vue&type=script&lang=js"
export * from "./ContactUsComp.vue?vue&type=script&lang=js"

import "./ContactUsComp.vue?vue&type=style&index=0&id=0010b525&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\LENOVO\\Documents\\workspace\\tulumoutdoor_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0010b525"]])

export default __exports__